import { shallowRef } from "vue";
import { defineStore } from "pinia";
import { incrementalId } from "../uikit.helpers/incrementalId.es.js";
import Modal from "../uikit.components/Modal/Modal.vue.es.js";
import { MODAL_PLACEMENT, MODAL_MOBILE_OFFSET } from "../uikit.components/Modal/modal.es.js";
const useModalStore = defineStore("uikit-modal", {
  state: () => ({
    modals: []
  }),
  getters: {
    offset: (state) => (id, placement) => {
      var _a, _b;
      if (MODAL_PLACEMENT.CENTER === placement) {
        return 0;
      } else if (MODAL_PLACEMENT.BOTTOM === placement) {
        const index = state.modals.findIndex((drawer) => drawer.id === id);
        const isActiveDrawer = index !== -1 && index === state.modals.length - 1;
        let offset = 0;
        if (isActiveDrawer) {
          offset = MODAL_MOBILE_OFFSET;
        } else {
          const activeDrawer = state.modals[state.modals.length - 1];
          if (activeDrawer && ((_a = activeDrawer == null ? void 0 : activeDrawer.instance) == null ? void 0 : _a.height)) {
            const factors = [0.7, 1.2, 1.5, 1.8];
            const indexInner = state.modals.length - index - 1;
            offset = ((_b = activeDrawer == null ? void 0 : activeDrawer.instance) == null ? void 0 : _b.height) + MODAL_MOBILE_OFFSET * factors[indexInner - 1];
          }
        }
        return offset;
      }
    },
    isActive: (state) => (id) => {
      const index = state.modals.findIndex((drawer) => drawer.id === id);
      return index !== -1 && index === state.modals.length - 1;
    },
    isVisible: (state) => (id) => !!state.modals.find((modal) => modal.id === id)
  },
  actions: {
    confirm(props) {
      const id = `modal-${incrementalId()}`;
      this.modals.push({
        id,
        component: shallowRef(Modal),
        props: { ...props, id },
        instance: null
      });
    },
    referenceInstance(id, instance) {
      const modal = this.modals.find((modal2) => modal2.id === id);
      if (modal) {
        modal.instance = instance;
      }
    },
    remove(modalId) {
      this.modals = this.modals.filter((modal) => modal.id !== modalId);
    },
    closeAll() {
      this.modals = [];
    }
  }
});
export {
  useModalStore
};
//# sourceMappingURL=modal.es.js.map
